// image
import logoIcon from 'assets/images/branding/george/george-logo-icon.svg';

// ==============================|| LOGO ICON PNG ||============================== //

const LogoIcon = ({ src }: { src?: string }) => {
  return (
    <img src={src || logoIcon} alt="Forsler" height="35px" />
  );
};

export default LogoIcon;
